<h2 mat-dialog-title>
  <mat-icon>outgoing_mail</mat-icon>
  Se inviterede brugere
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  @if (filterModel) {
    <div class="dialog__queries" [formGroup]="filterModel">
      <mat-form-field>
        <mat-label>Søg brugere</mat-label>
        <input matInput placeholder="E-mail adresse" formControlName="query" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <adm-org-typeahead
        [initialId]="undefined"
        [resetTrigger]="resetOrgTrigger()"
        (itemSelected)="organizationSelected($event)"
        (clearTypeAhead)="resetFilter()" />
      <mat-form-field>
        <mat-label>Vælg status</mat-label>
        <mat-select #statusSelect formControlName="selectedStatus" name="selectedStatus" okCustomDropDownArrowDirective>
          <mat-option [value]="null">Alle</mat-option>
          @for (status of statuses | enumToArray | translateInvitationStatusEnum; track status) {
            <mat-option [value]="status.index">
              {{ status.name }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
      <button (click)="resetFilter()" class="actions__reset" mat-stroked-button>Nulstil</button>
    </div>
  }
  <div>
    @if ((appState.isInErrorState$ | async) === false) {
      <adm-loading-spinner [loading$]="loading$"></adm-loading-spinner>
      <table
        #invitationList
        mat-table
        [dataSource]="data$"
        [class.loading-blur]="loading$ | async"
        [class.loading-blur--done]="(loading$ | async) === false"
        class="invitation-table"
        matSort
        (matSortChange)="sortData($event)">
        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">E-mail adresse</th>
          <td
            mat-cell
            *matCellDef="let invitation"
            class="row"
            [matTooltip]="invitation.emailAddress"
            [matTooltipPositionAtOrigin]="'true'">
            {{ invitation.emailAddress }}
          </td>
        </ng-container>
        <ng-container matColumnDef="organization">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="organizationName" class="col">Organisation/afdeling</th>
          <td mat-cell *matCellDef="let invitation" class="row">
            {{ invitation.organizationName }}
            <span>
              <mat-icon>subdirectory_arrow_right</mat-icon>
              {{ invitation.departmentName }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="invitationStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Status</th>
          <td mat-cell *matCellDef="let invitation" class="row">
            {{ invitation.invitationStatus | translateInvitationStatusEnum }}
          </td>
        </ng-container>
        <ng-container matColumnDef="updatedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Ændret af</th>
          <td mat-cell *matCellDef="let invitation" class="row">
            {{ invitation.updatedBy }}
          </td>
        </ng-container>
        <ng-container matColumnDef="updated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Senest ændret</th>
          <td mat-cell *matCellDef="let invitation" class="row" title="{{ invitation.updated | date: 'dd.MM.yyyy HH:mm:ss' }}">
            {{ invitation.updated | date: 'short' }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let rowData; columns: displayColumns" [class.highlight]="rowData.highlight | async"></tr>
      </table>
      @if ((data$ | async)?.length === 0 && (loading$ | async) === false) {
        <div class="no-results">
          <p>Der blev ikke fundet nogen invitationer</p>
        </div>
      }
      <mat-paginator
        #paginator
        [pageSize]="pagingOptions.pageSize"
        [pageIndex]="pageIndex"
        [length]="invitationCount"
        [pageSizeOptions]="pagingOptions.pageSizeOptions"
        (page)="pageSwitch($event)"
        color="accent"></mat-paginator>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>
